import us from '../../defines';
import app from '../../public-api';
import {env} from '../../lib/utility/browser-compatibility';
import * as CONSTANTS from './constants';
import factory from './conferencing-factory';
import { translate } from 'shared/services/I18nService';
import StateVector from './StateVector';

app.plugins.register({
  name: 'us:conferencing',

  extends: 'uScope',

  canStart (uScope) {
    return !env.isIOS && uScope.toolbarCanAddButton('dscSetupBtn');
  },

  constructor: function (uScope) {
    const conferencingService = factory.createService(uScope);

    addToolbarButton(conferencingService, uScope);
  }
});

app.plugins.register({
  name: 'us:conferencing:state-vector',

  extends: 'viewport',

  canStart (uScope) {
    return !env.isIOS && uScope.toolbarCanAddButton('dscSetupBtn');
  },

  constructor: StateVector
});

const addToolbarButton = (conferencingService, uScope) => {
  const button = $('<a/>', {
    'id': CONSTANTS.CREATE_BUTTON_ID,
    'class': us.clsTBBUTTON + ' ' + CONSTANTS.CREATE_BUTTON_ID + '-e',
    'title': translate('uScope.extensions.conferencing.icon-title')
  });

  const handleMainButtonClick = (event) => {
    if (!conferencingService.isInConference()) {
      conferencingService.confCreate();
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    return false;
  };

  button.on('click', handleMainButtonClick);

  uScope.topToolbar.addButton(button);
};



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/conferencing/conferencing-service-loader.js